import React from "react";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "../styles/Home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  const navigate = useNavigate();

  const testimonials = [
    {
      quote:
        "Working with Westfield Transport Ltd. has been an outstanding experience. Their consistent professionalism, timely deliveries, and attention to detail have made a noticeable difference in our supply chain operations. From the first shipment onward, their team has shown a strong commitment to service and reliability that we can truly depend on.",
      name: "Mohit Sharma",
      title: "Owner, AM Interstate Haulers",
    },
    {
      quote:
        "Their fleet is top-notch, and their service is second to none. Westfield Transport has consistently gone above and beyond to ensure our freight is delivered safely and on time. Their communication, reliability, and attention to detail give us complete confidence in every shipment. It’s rare to find a transport partner that truly understands the importance of logistics to a business. We highly recommend them to anyone looking for a dependable and professional freight solution."
,
      name: "Ryan Nelson",
      title: "Logistics Manager, Magicmax Logistics",
    },
  ];

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 6000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  

  return (
    <div className="home-container">
      <header
        className="hero-banner"
        style={{
          backgroundImage: `url("/img/hero-banner.png")`,
        }}
      >
        <div className="hero-overlay">
          <h1>Westfield Transport Ltd.</h1>
          <p>Reliable. Professional. Dedicated to Delivery.</p>
          <button className="cta-button" onClick={() => navigate("/contact")}>
            REQUEST QUOTE
          </button>
        </div>
      </header>

      

      <section className="why-choose-us">
        <h2>Why Choose Us?</h2>
        <div className="feature-cards">
          <div className="feature-card">
            <h3>Dependable Trucking</h3>
            <p>
              Your cargo isn’t just freight, it’s a promise we deliver with care and consistency.
            </p>
          </div>
          <div className="feature-card">
            <h3>Wide Coverage</h3>
            <p>
              Our routes span key hubs across Western Canada and into the U.S. for smooth cross-border shipping.
            </p>
          </div>
          <div className="feature-card">
            <h3>Client-Focused</h3>
            <p>
              We build long-term relationships with flexible service options and dedicated support.
            </p>
          </div>
        </div>
      </section>

      <section className="our-services">
        <h2>Our Services</h2>
        <div className="feature-cards">
          <div className="feature-card">
            <h3>Freight Transportation</h3>
            <p>Secure and reliable freight transport across Canada and the U.S.</p>
          </div>
          <div className="feature-card">
            <h3>Dedicated Trucking</h3>
            <p>Non-stop, direct delivery tailored to your schedule and routes.</p>
          </div>
          <div className="feature-card">
            <h3>Flexible Solutions</h3>
            <p>Custom logistics services based on your unique business needs.</p>
          </div>
        </div>
      </section>
      <section className="about-us">
        <h2>About Us</h2>
        <p>
          Westfield Transport Ltd. is a full-service transportation company specializing in
          safe, reliable, and efficient freight delivery across Canada and the United States. With a
          customer-first mindset and a modern fleet, we are committed to building long-term partnerships
          through exceptional service, operational excellence, and innovative logistics solutions.
          <br /><br />
          Our operations are rooted in professionalism, transparency, and the highest safety standards. We
          take pride in delivering goods securely and on time, every time. From regional hauls to
          cross-border logistics, Westfield Transport is your trusted partner in freight movement.
        </p>
      </section>
      <section className="customer-testimonials">
  <h2>Customer Testimonials</h2>
  <div className="testimonial-carousel-wrapper">
    <Slider {...sliderSettings}>
      {testimonials.map((t, index) => (
        <div key={index} className="testimonial-slide">
          <blockquote>“{t.quote}”</blockquote>
          <p className="testimonial-author">– {t.name}, {t.title}</p>
        </div>
      ))}
    </Slider>
  </div>
</section>


      {/* Optional CTA section */}
      {/* <section className="call-to-action">
        <h2>Need a Reliable Transport Partner?</h2>
        <p>Let us handle your freight with speed and care. Get in touch today.</p>
        <button className="cta-button" onClick={() => navigate("/contact")}>Contact Us</button>
      </section> */}

      <Footer />
    </div>
  );
};

export default Home;
